export const setLocal = (lc) =>{
  return {
      type:'SETLOCAL',
      payload: lc,
  }
};
